import { useSelector } from "react-redux";
import FitSummary from "../../reviews/fit-summary";
import ReviewStars from "../../shared/review-stars";
import PropTypes from "prop-types";
import FeaturedReviewImageCarousel from "./featured-review-images/featured-review-image-carousel";
import EmptyReviewsPreview from "./empty-reviews-preview";

export default function ReviewsPreview(props) {
  const reviewCount = useSelector(state => state.reviews?.count || 0);
  const reviewAverageRating = useSelector(state => state.reviews?.averageRating || 0);
  const reviewFitCount = useSelector(state => state.reviews?.summary?.fitCounts);

  if (reviewCount === 0) {
    return <EmptyReviewsPreview />;
  }

  return (
    <div className="reviews-preview" data-test-id="reviews-preview">
      <FeaturedReviewImageCarousel productId={props.productId} />

      <div className="inline-block review-stars">
        <p className="review-rating body-3-size">
          {Number.isInteger(reviewAverageRating) && parseFloat(reviewAverageRating / 2).toFixed(1)}
        </p>
        <ReviewStars imageName={`BlackStars${Math.floor(reviewAverageRating)}`} />
        {reviewCount ? (
          <a
            className="review-stars__review-count inline-block body-3-size"
            href={`/product_reviews/${props.productId}`}>
            {"("}
            <p>{`${reviewCount} Reviews`}</p>
            {")"}
          </a>
        ) : (
          ""
        )}
      </div>

      <FitSummary fitCounts={reviewFitCount} />

      <a
        className={`review-preview__cta semibold`}
        onClick={() => props.logReadAllReviews(props.productId)}
        href={`/product_reviews/${props.productId}`}>
        Browse All Reviews
      </a>
    </div>
  );
}

ReviewsPreview.propTypes = {
  logReadAllReviews: PropTypes.func,
  productId: PropTypes.string,
};
